// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pcRg","index":"styles_index__2TALi"};